import router from "@/router";
import {Product} from "@/data/classes/product";
import {getValue, goToFireStore} from "@/globalFunctions";
import {MessageBox} from "element-ui";
import i18n from "@/lang";
import {ProductModule} from "@/store/modules/product";

export const filters = [
    {
        field:"active",
        clearable: true,
        options: [
            { key: true, label: 'table.status-active' },
            { key: false, label: 'table.status-inactive' }
        ],
        placeholder: 'table.status'
    },{
        field: "sort",
        clearable: true,
        options: [
            { label: 'table.order.id-asc', key: 'Id-asc' },
            { label: 'table.order.id-desc', key: 'Id-desc' },
            { label: 'table.order.title-asc', key: 'Title-asc' },
            { label: 'table.order.title-desc', key: 'Title-desc' },
        ],
        placeholder: 'table.sort'
    }
];

export const columns = [
    {
        label: 'table.product-title',
        field: "Title.NL",
        formatter: (x : any) => {
            return x.substr(0, 30);
        }
    },
    {
        label: 'table.product-type',
        field: "Price.Type",
        formatter: (x : any) => {
            return i18n.t("product-form." + x);
        }
    },
    {
        label: 'table.limit-exceed',
        field: "Info.AllowLimitExceed",
        formatter: (x : any) => {
            return x ? i18n.t("product-form.allow-limit-exceed-true") : i18n.t("product-form.allow-limit-exceed-false");
        }
    },
    {
        label: 'table.product-base-price',
        field: "Price",
        formatter: (x : any) => {
            if (x.Type === "one_time"){
                const euros = Math.floor(x.Amount/100);
                const cents = (x.Amount - euros*100).toString()
                return "&euro;" + euros + "," + (cents.length === 1 ? '0' + cents : cents) + " / " + x.BaseTier.UpTo + " " + i18n.t("table.scans");
            } else {
                const euros = Math.floor(x.BaseTier.FlatAmount/100);
                const cents = (x.BaseTier.FlatAmount - euros*100).toString();
                return "&euro;" + euros + "," + (cents.length === 1 ? '0' + cents : cents) + " / " + x.BaseTier.UpTo + " " + i18n.t("table.scans-per-" + x.Interval);
            }
        }
    },
    {
        label: 'table.product-extra-price',
        field: "Price",
        formatter: (x : any) => {
            if (!x.ExtraTier.UnitAmount || x.Type !== "recurring"){
                return "-"
            } else {
                const euros = Math.floor(x.ExtraTier.UnitAmount/100);
                const c = (x.ExtraTier.UnitAmount - euros*100).toString();
                const cents = c.indexOf(".") < 0 ? c : (c.split(".").shift() || "0");
                const decimals = c.indexOf(".") < 0 ? "" : (c.split(".").pop() || "");
                return "&euro;" + euros + "," + (cents.length === 1 ? '0' + cents : cents) + decimals + " " + i18n.t("table.per-scan");
            }
        }
    }
];

export const actions = [
    {
        label: 'table.edit',
        command: "edit",
        icon: "edit",
        type: 'info',
        click: (row : any) => {
            router.push("/ecommerce/products/" + row.Id);
        }
    },
    {
        label: 'table.firestore',
        command: "toFireStore",
        icon: "local_fire_department",
        type: 'warning',
        click: (row : any) => {
            goToFireStore({
                type: "product",
                productId: row.Id
            });
        }
    },
    {
        label: 'table.delete',
        command: "delete",
        icon: 'delete',
        type: 'danger',
        click: (row : any) => {
            MessageBox({
                title: i18n.t('confirmations.delete-product.title').toString(),
                message: i18n.t('confirmations.delete-product.text').toString(),
                showCancelButton: true,
                confirmButtonClass: "el-button--info",
                cancelButtonClass: "el-button--danger",
                confirmButtonText: i18n.t('confirmations.default.confirmation-button').toString(),
                cancelButtonText: i18n.t('confirmations.default.cancel-button').toString(),
            }).then(async () => {
                window.GlobalEvents.$emit("start-list-load");
                return ProductModule.list.archive(row.Id).then(() => {
                    window.GlobalEvents.$emit("refresh-list");
                })
            });
        }
    }
];

export const getData = async (listQuery : any) => {
    // Get items
    if (!ProductModule.list._retrieved || !ProductModule.list._admin){
        await ProductModule.list.get(true)
    }

    let items = ProductModule.list.toList();

    // Query
    if (listQuery.active === true || listQuery.active === false){
        items = items.filter((x: Product) => x.Active === listQuery.active);
    }

    // Sort
    if (listQuery.sort){
        const [field, order] = listQuery.sort.split("-")
        items = items.sort((a: any, b: any) => {
            if(getValue(a, field) < getValue(b, field)) { return order === 'asc' ? -1 : 1; }
            if(getValue(a, field) > getValue(b, field)) { return order === 'asc' ? 1 : -1; }
            return 0;
        });
    }

    return {
        data: {
            items: items,
            total: items.length
        }
    };
};
